import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { BpValueChangeBadgeComponent } from "@modules/shared/bp-value-change-badge/bp-value-change-badge.component";
import { CoreModule } from "@modules/core/core.module";

@NgModule({
	declarations: [BpValueChangeBadgeComponent],
	exports: [BpValueChangeBadgeComponent],
	imports: [CommonModule, CoreModule]
})
export class BpValueChangeBadgeModule {}
